(function () {
  'use strict';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var doc = document.documentElement;
  var GOLD = ['#b98f3e', '#d9bd7d', '#e3cf9f', '#ffffff'];

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html) n.innerHTML = html;
    return n;
  }

  function init() {
    var bar = el('div', 'lx-progress');
    bar.setAttribute('aria-hidden', 'true');
    document.body.appendChild(bar);

    var top = el('button', 'lx-top', '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 14l6-6 6 6"/></svg>');
    top.type = 'button';
    top.setAttribute('aria-label', 'Back to top');
    top.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    });
    document.body.appendChild(top);

    var ticking = false;
    function frame() {
      ticking = false;
      var y = window.pageYOffset || doc.scrollTop;
      var max = Math.max(1, doc.scrollHeight - window.innerHeight);
      bar.style.transform = 'scaleX(' + Math.min(1, y / max) + ')';
      doc.classList.toggle('lx-scrolled', y > 40);
      top.classList.toggle('is-on', y > 900);
      if (!reduce) {
        var hero = document.querySelector('.hero__media-grid');
        if (hero && y < 1200) hero.style.setProperty('--lx-par', Math.min(y * 0.08, 28).toFixed(1) + 'px');
      }
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(frame); }
    }, { passive: true });
    frame();

    var toast = el('div', 'lx-toast', '<span class="lx-toast__tick" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg></span><span>Added to your bag</span><a href="/cart">View bag</a>');
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    document.body.appendChild(toast);
    var toastTimer;
    function showToast() {
      toast.classList.add('is-on');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { toast.classList.remove('is-on'); }, 3600);
      if (reduce) return;
      document.querySelectorAll('[class*="cart-bubble"], cart-icon').forEach(function (b) {
        b.classList.remove('lx-pop');
        void b.offsetWidth;
        b.classList.add('lx-pop');
      });
    }
    if (window.fetch) {
      var orig = window.fetch;
      window.fetch = function (input) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var p = orig.apply(this, arguments);
        if (/\/cart\/add/.test(url)) {
          p.then(function (r) { if (r && r.ok) showToast(); }).catch(function () {});
        }
        return p;
      };
    }

    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.kv-copy');
      if (!b || reduce) return;
      var r = b.getBoundingClientRect();
      for (var i = 0; i < 14; i++) {
        var s = el('i', 'lx-spark');
        var a = (Math.PI * 2 * i) / 14 + Math.random() * 0.4;
        var d = 36 + Math.random() * 34;
        s.style.left = r.left + r.width / 2 + 'px';
        s.style.top = r.top + r.height / 2 + 'px';
        s.style.background = GOLD[i % GOLD.length];
        s.style.setProperty('--dx', Math.cos(a) * d + 'px');
        s.style.setProperty('--dy', Math.sin(a) * d + 'px');
        document.body.appendChild(s);
        setTimeout(function (n) { n.remove(); }.bind(null, s), 800);
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
